import React from 'react';

export function Sparkline({ data, width = 48, height = 20, color = 'var(--accent)' }) {
  if (!data || data.length < 2) return null;
  const max   = Math.max(...data);
  const min   = Math.min(...data);
  const range = max - min || 1;
  const pts   = data.map((v, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((v - min) / range) * (height - 4) - 2; // 2px padding
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  const last = pts.trim().split(' ').slice(-1)[0].split(',');
  return (
    <svg width={width} height={height}
      style={{ display:'block', overflow:'visible', flexShrink:0 }}>
      <polyline points={pts} fill="none" stroke={color}
        strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx={last[0]} cy={last[1]} r="2.5" fill={color}/>
    </svg>
  );
}

export function topWeightForExercise(workout, exerciseName) {
  const ex = workout.exercises?.find(e => e.name === exerciseName);
  if (!ex || !ex.sets?.length) return 0;
  return Math.max(...ex.sets.map(s => s.weight || 0));
}
